import { BOGeneralValues } from "./BOGeneralValues.model";
import { BOSellDetail } from "./BOSellDtail.model";

export class BOPayTypeSellDetail {
    id:number;
    sellId?:number;
    payTypeId?:number;
    datePayTypeSellDetail?:Date | undefined;
    numberPayTypeSellDetail?:string;

    userName?:string;
    userId?:number; //
    userIdString?:string; // No. de Identidad
    payTypeSellDetailBank?:string;
    payTypeSellDetailObservations?:string;
    invoiceTypeId?:number;
    invoiceTypeName?:string;
    price:number=0;
    areaId?:number;
    //adicional data no mapped
    payTypeIdTemp?:number;
    payTypeName?:string;
    sellDetail?:BOSellDetail=new BOSellDetail();
    idTypeIdentification?:number;


}
